import React, { createContext, useContext, useState } from 'react';
import {fetchPartner, CreatePartner, validateToken, generatePassword} from '../../services/api';
import {fetchPartnerbyId, UpdatePartner,checkEmail, Createemployee, FetchEmployee, fetchEmployeeById, Updateemployee, deleteEmployeeById, deletePartnerById, EnablePartnerbyID, checkPhonenumber, FetchProductCategory, CreateProduct, UpdateProduct, regenerateActivationLink} from '../../services/Partner/PartnerApi'

const PartnerContext = createContext();

export const PartnerProvider = ({ children }) => {
    const [partners, setPartners] = useState([]);
    const [partner, setPartner] = useState([]);    
    const [validated, setValid] = useState(false);
    const [embployee, setEmployee] = useState([]); 
    const [ProductCategory, setProductCategory] = useState([]); 
    const [updatedembployee, setUpdatedEmployee] = useState([]); 
    const FetchPartners = async() => {

        const response =await fetchPartner();
        setPartners(response.data);
    };

    const AddPartners = async (partner,file,iconFile) => {    
      
       
        const result = await CreatePartner(partner, file,iconFile);
       
        return result.data; 
    };
    const Addemployee = async (employee) => {
   
        const result = await Createemployee(employee);
        setEmployee(result.data); 
        return result.data;
    };
    const GetEmployeeByID = async (cat) => {
        const result = await fetchEmployeeById(cat);
        debugger;
        setUpdatedEmployee(result.data);
    };
    const updateEmployee = async (cat) => {     
           
        const result = await Updateemployee(cat);
        setEmployee(result.data); 
        return result.data;
    };
    const GetEmployee = async (cat) => {
       
        const result = await FetchEmployee(cat)
        debugger;
        setEmployee(result.data);
    };
    const FetchProductCategories = async (cat) => {

        const result = await FetchProductCategory(cat)
        debugger;
        setProductCategory(result.data);
    };
    const AddNewProduct = async (product) => {

        const result = await CreateProduct(product);
        setEmployee(result.data);
        return result.data;
    };
    const UpdateExistingProduct = async (product) => {
        const result = await UpdateProduct(product);
        return result;
    };
    const deleteEmployee = async (id) => {  
         
        const result = await deleteEmployeeById(id);
        setEmployee(result.data); 
    };
    const deletePartner = async (id) => {  
              
        const result = await deletePartnerById(id);
        setPartners(result.data); 
    };
    const Activate = async (token) => {
      
        const result = await validateToken(token);
        if (result.data.isValid === true) {          
            
            setValid(true);
            return result.data.partner;
        } else {
            setValid(false);
            return null;
        }
       
    };
    const GeneratePassword = async (UserID, Password) => {
      
        return await generatePassword(UserID, Password);
       
    };

    const FetchEditPartner = async (id) => {           
        const data = await fetchPartnerbyId(id); // Fetch single branch data
        
            setPartner(data); // Set the current branch
            
    };

    const RegenerateActivationLink = async (id) => {
        const data = await regenerateActivationLink(id);
        setPartner(data);
        return data;
    };

    const EditPartners = async (partner,iconFile,file) => { 
        const result = await UpdatePartner(partner,file,iconFile);
        setPartner(result.data); 
        return result.data;
    };

    const EnablePartner = async (id) => {       
        const result = await EnablePartnerbyID(id);
        setPartner(result); 
    }; 

     const checkEmailExistance = async (email) => {           
           return await checkEmail(email); // Fetch single branch data
         
            
    };

    const checkPhoneExistance = async (email) => {           
        return await checkPhonenumber(email); // Fetch single branch data     
    };
    
    return (
        <PartnerContext.Provider value={{ partners, partner, updatedembployee, deletePartner, deleteEmployee, updateEmployee, GetEmployeeByID, embployee, GetEmployee, setPartners, FetchPartners, Addemployee, AddPartners, Activate, validated, GeneratePassword, FetchEditPartner, RegenerateActivationLink, EditPartners, checkEmailExistance, EnablePartner, checkPhoneExistance, FetchProductCategories, ProductCategory, AddNewProduct, UpdateExistingProduct } }>
            {children}
        </PartnerContext.Provider>
    );
};

export const usePartnerContext = () => useContext(PartnerContext);
